<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col cols="12">
          <h3 class="text-center">Contents <span class="smh"></span></h3>
        </b-col>
        
      </b-row>
      <b-row>
        <b-col class="mt-3">
          <h3 class="text-center">Uploaded Contents</h3>
          <p class="text-center">Click on any title to preview and edit</p>
          <div class="text-center list-heads pt-1">
              <p class="head-p">S/N</p>
              <p class="head-p">Title</p>
              <p class="head-p">Subject</p>
              <p class="head-p">Body</p>
              <p class="head-p">Target</p>
              <p class="head-p">Release date</p>
              <p class="head-p">Image</p>
              <p class="head-p"></p>
          </div>

          <div v-if="contentsarray[0].count > 0">
              <contents-list class="mt-2 maxres" v-for="(content, index) in usecontentsarray" :sn="index + 1" :content="content" :key="index" :page="pages" :interval='intervalnum'></contents-list>
              <paginater v-if="contentsarray[0].data.length > 0" :intervalnum="intervalnum" :pages="pages" :endss="endss" :endnum="endnum" :datalength="endss" @paginator="newPage" @changeInterval="effectInterval"></paginater>
          </div>
          <div v-else>
              <h3>No contents Yet</h3> 
          </div>
          
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import store from "@/store"
import contentsList from '@/components/admin/contentsList';
import Paginater from "@/components/Paginater"
// import  ckeditor  from "@/js/ckeditorconfig"
// const { ClassicEditor, config } = ckeditor
// import axios from "axios";

export default {
  components: {
      contentsList,
      Paginater
  },

  data() {
    return {
        sending: false,
        sent : false,
        levels: [0, 1, 2, 3, 4, 5],
        startnum: 0,
        limitnum: this.endss,
        intervalnum: 10,
        endnum: 10,
        btnrange : this.endss,
        pages : 1,
        stockingdata : [{
            data : []
        }],
        dataretrieved : false,
        addresponse : "",
        opencreate : false,
        // editor : ClassicEditor,
        // config : config,
        isCheckingcode : false,
        contentexists : false,
        uploadingfile : false,
        uploadedfile : false,
        uploadmessage : "",
        mtype : "",
        filedir : ""
        // datacount : this.partnershipsarray[0].count
    };
  },
  beforeRouteEnter(to, from, next){

    //   let orgname = store.state.loginmaster.details.clearance_organization
        store.dispatch("admin/fetchContents")
        next();

      
  },
  computed: {
    ...mapState({
        users: (state) => state.admin.allusers,
        details : state => state.loginmaster.details,
        contentsarray : state => state.admin.contents,
        adminadded : state => state.admin.adminadded,
        environ : state => state.loginmaster.environ,
        origin : (state) => state.loginmaster.site_origin
    }),
    emails() {
      let emailss = this.users;
      return emailss.map((x) => x.email);
    },
    usecontentsarray() {
        return this.contentsarray[0].data.slice(this.startnum, this.endnum);
    },
    endss() {
        let end = this.contentsarray[0].data.length;
        return end;
    },
    ranger(){
        let ranger = Math.ceil(this.contentsarray[0].data.length/this.intervalnum)
        return ranger
    },
  },
  methods: {
        ...mapActions("admin", ["fetchContents"]),
        newPage(page){
            // alert(page)
            this.pages = page
            let newend = this.intervalnum * page;

            if (newend < this.endss) {
                this.endnum = newend;
                this.startnum = newend - this.intervalnum ;
            } else {
                this.endnum = this.endss;
                this.startnum = newend - this.intervalnum ;
            }

        },
        effectInterval(newinterval){
            this.intervalnum = newinterval
            this.pages = 1
            this.newPage(this.pages)
        },
        stopproceed(){
            this.sending = false
        },
  },
  
};
</script>

<style scoped>
.list-heads {
    background-color: #00984A;
    color: white;
    border-radius: 5px 5px;
    font-weight: bold;
    display: flex;
    flex-flow: row wrap;
}
.head-p{
    width: 11%;
    padding: 2px;
}
.flex-input-parent{
    display: flex;
}
.left-flex-child{
    width: 95%;
}
.right-flex-child{
    width: 5%;
}
.hidden{
    display: none
}
.full-width-child{
    width : 100%
}
.font-green{
    color: green;
}
.errtxt{
    color: red;
}


@media screen and (max-width: 999px) {
     .head-p{
        font-size: 0.6rem
    }
    .page-buttons{
        width: 25px;
        height: 25px;
        padding: 0px 0px 0px 5px ;
    }
}
</style>
